import { Controller } from "@hotwired/stimulus"

// Swaps the claim document chrome (CMS-1500 vs UB-04) when the operator
// changes claim type. All of the visual work is done in CSS via
// group-data-[claim-type=...] variants on the section; this controller only
// keeps the section's data attribute in sync with the select.
export default class extends Controller {
  update(event) {
    this.element.dataset.claimType = event.target.value
  }
}
